import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import SocialLinks from '/components/SocialLinks';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import SimpleForm from '/components/SimpleForm';

export default function MultiColumnCTAWithDivider({
    global,
    pathPrefix,
    customClass = "",
    right_content,
    left_content,
    buttonLink1,
    buttonTitle1,
    buttonLink1NewTab = false,
    buttonLink2,
    buttonTitle2,
    buttonLink2_1,
    buttonTitle2_1,
    popUpModal_1 = false,
    popUpModal_2 = false,
    popUpModal_1_form_id,
    popUpModal_2_form_id,
    dialog_content_1,
    dialog_content_2,
    successPageUrl
}) {
    Fancybox.bind("[data-src]", {
        // Your custom options
    });
    return (
        <section className={`${styles.root} ${customClass} py-1`}>
            <Container>
                <Row className="m-0">
                    <Col md={6} className="left-column ps-0 pe-0 pe-md-5 py-5">
                        {left_content ?
                            <div className="mb-4">
                                <SourceFlowText global={global} path={`${pathPrefix}.left_content`} type="html">
                                    {left_content}
                                </SourceFlowText>
                            </div> : null}
                        {buttonLink1 ?
                            <div>
                                <Link href={`${buttonLink1}`}>
                                    {buttonLink1NewTab ?
                                        <a className="primaryBtn no-arrow m-0" target="_blank" rel="noopener noreferrer">
                                            {buttonTitle1}
                                        </a> : <a className="primaryBtn no-arrow m-0">
                                            {buttonTitle1}
                                        </a>
                                    }
                                </Link>
                            </div> : null}
                        <div className="mt-5">
                            <p><strong>Follow us</strong></p>
                            <SocialLinks
                                customClass="social-links"
                            />
                        </div>
                    </Col>
                    <Col md={6} className="right-column ps-0 ps-md-5 pe-0 py-5">
                        {right_content ?
                            <div className="mb-4">
                                <SourceFlowText global={global} path={`${pathPrefix}.right_content`} type="html">
                                    {right_content}
                                </SourceFlowText>
                            </div> : null}
                        <div>
                            {popUpModal_1 ?
                                <button className="border-0 fancyBox primaryBtn no-arrow" data-src={`#${pathPrefix}.dialog-content-1`}>
                                    {buttonTitle2}
                                </button> :
                                <>
                                    {buttonTitle2 && buttonLink2 && (
                                        <Link href={`${buttonLink2}`}>
                                            <a className="primaryBtn no-arrow">
                                                {buttonTitle2}
                                            </a>
                                        </Link>
                                    )}
                                </>
                            }
                            {popUpModal_2 ?
                                <button className="border-0 fancyBox secondaryBtn no-arrow" data-src={`#${pathPrefix}.dialog-content-2`}>
                                    {buttonTitle2_1}
                                </button>
                                :
                                <>
                                    {buttonTitle2_1 && buttonLink2_1 && (
                                        <Link href={`${buttonLink2_1}`}>
                                            <a className="secondaryBtn no-arrow">
                                                {buttonTitle2_1}
                                            </a>
                                        </Link>
                                    )}
                                </>
                            }
                        </div>
                        {popUpModal_1_form_id ?
                            <div class="dialog-content" id={`${pathPrefix}.dialog-content-1`}>
                                <div>
                                    {dialog_content_1 ?
                                        <>
                                            <SourceFlowText global={global} path={`${pathPrefix}.dialog-content-1`} type="html">
                                                {dialog_content_1}
                                            </SourceFlowText> <hr></hr>
                                        </> : null}

                                    <SimpleForm
                                        formId={`${popUpModal_1_form_id}`}
                                        successPageUrl={`${successPageUrl}`}
                                    />
                                </div>
                            </div> : null}
                        {popUpModal_2_form_id ?
                            <div class="dialog-content" id={`${pathPrefix}.dialog-content-2`}>
                                <div>
                                    {dialog_content_2 ?
                                        <>
                                            <SourceFlowText global={global} path={`${pathPrefix}.dialog-content-2`} type="html">
                                                {dialog_content_2}
                                            </SourceFlowText><hr></hr></> : null}
                                    <SimpleForm
                                        formId={`${popUpModal_2_form_id}`}
                                        successPageUrl={`${successPageUrl}`}
                                    />
                                </div>
                            </div> : null}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}